import script from "./bankTransferButton.vue?vue&type=script&setup=true&lang=js"
export * from "./bankTransferButton.vue?vue&type=script&setup=true&lang=js"

import "./bankTransferButton.vue?vue&type=style&index=0&id=6d9e80d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9e80d4"]])

export default __exports__